var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 40,
    viewBox: "0 0 218 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.698 19.9965C115.698 10.0296 123.9 1.94644 133.622 1.94644C143.351 1.94644 151.545 10.0296 151.545 19.9965C151.545 29.9711 143.351 38.0482 133.622 38.0482C123.9 38.0482 115.698 29.9711 115.698 19.9965ZM133.621 0C122.847 0 113.586 8.95327 113.586 19.9965C113.586 31.0414 122.847 39.9951 133.621 39.9951C144.404 39.9951 153.669 31.0414 153.669 19.9965C153.669 8.95327 144.404 0 133.621 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8362 0.875H55.625L73.8028 40H74.0078L92.1856 0.875H89.9831L78.9099 24.7355L73.9118 35.787L68.9269 24.7355L57.8362 0.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.461 38.9069H184.498V19.9965L184.389 4.86282L216.906 39.9929H217.111V0.86789H215.075V19.9965L215.184 35.1214L182.662 0H182.461V38.9069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06095 26.3016L13.291 15.0377L18.272 3.97313L23.332 15.0612L28.511 26.319L8.06095 26.3016ZM18.3902 0H18.1682L0 38.9043H2.21466L7.27984 27.9903L29.2746 27.9815L34.3529 38.9043H36.5575L18.3902 0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb10);
export default __webpack_public_path__ + "static/media/ab (10).8f796edeb61c56da3c93fceeaead4e76.svg";
export { ForwardRef as ReactComponent };